import type { ReactNode } from 'react';

/**
 * Renders a formatted number/price string with its decimal portion visually
 * de-emphasized (smaller + lighter) — a long comma-grouped integer part (e.g.
 * "182,521") can otherwise make a trailing decimal (".82") easy to miss, and
 * at small sizes the decimal point itself can be mistaken for one of the
 * thousands-separator commas. Splitting out the tail after the LAST "." makes
 * it visually unambiguous which punctuation mark is the actual decimal point.
 *
 * Works on any already-formatted string (e.g. `toLocaleString` output, with
 * or without a leading "$"); strings with no "." (whole numbers, "-", "?")
 * render unchanged.
 */
export function PriceText({ value }: { value: string }): ReactNode {
  const dot = value.lastIndexOf('.');
  if (dot === -1) return value;
  return (
    <>
      {value.slice(0, dot)}
      <span className="price-text__decimals">{value.slice(dot)}</span>
    </>
  );
}
